import { render, staticRenderFns } from "./RequestListWrapper.vue?vue&type=template&id=6b835ff5&"
import script from "./RequestListWrapper.vue?vue&type=script&lang=js&"
export * from "./RequestListWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/SChaikovskiy/Desktop/AlsecoPO/GIT/alseco-power-online-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardActions,VDialog,VSpacer})
